module.exports = __webpack_public_path__ + "a17d279f/img/arrow-left-icon.785c715c.svg";